<template>
  <div class="login-page">
    <p class="login-title">登 录</p>
    <div class="account-box">
      <van-form label-width="1.25rem" validate-first @submit="onSubmit">
        <van-field
          v-model="personid"
          clearable
          label="账号"
          name="personid"
          left-icon="manager"
          placeholder="请输入账号"
          :rules="[{ required: true, message: '账号不能为空' }]"
        />
        <van-field
          v-model="password"
          type="password"
          clearable
          label="密码"
          name="password"
          left-icon="lock"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '密码不能为空' }]"
        />
        <van-field
          v-model="loginInfo.imgcode"
          center
          clearable
          label="验证码"
          name="imgcode"
          placeholder="请输入验证码"
          left-icon="font"
        >
          <template #button>
            <img
              slot="suffix"
              :src="imgCodeSrc"
              height="28"
              alt="点击更换验证码"
              @click="getPictureCode"
            />
          </template>
        </van-field>
        <div style="margin-top: 68px">
          <van-button class="btn login-btn" type="info" native-type="submit"
            >登 录</van-button
          >
        </div>
      </van-form>
      <div class="tip">
        <span @click="toForget">忘记密码</span>
        <span style="margin: 0 16px">|</span>
        <span @click="toRegister">快速注册</span>
      </div>

      <!-- <transition name="van-fade">
        <div v-show="showDocFlag">
          <p class="">
            根据编号{{
              attorneyNo
            }}授权书内容，您在“国贸云商外贸助手”操作的一切行为均视同为{{
              username
            }}的行为，由此引发的全部法律责任和法律后果均由{{ username }}方承担。
          </p>
          <div class="btn-group">
            <van-button class="" type="default" @click="changeShowDoc">
              >取 消</van-button
            >
            <van-button class="" type="info">同 意</van-button>
          </div>
        </div>
      </transition> -->
    </div>
  </div>
</template>

<script>
import { Image, Notify, Dialog } from "vant";
import axios from "axios";
import MobileDetect from "mobile-detect";

export default {
  name: "Login",
  components: {
    [Image.name]: Image,
  },
  data: function() {
    return {
      loginInfo: {
        personid: "",
        password: "",
        imgcode: "",
      },
      attorneyNo: "", //授权书编号
      username: "", //用户名
      checked: false, // 是否勾选协议
      showDocDialogFlag: false, // 是否显示告知书弹窗
      personid: "",
      password: "",
      loadingText: "",
      imgCodeSrc: "",
      idenCodeStatus: false, //图形验证码校验结果
      rules: {
        personid: [
          { required: true, message: "请输入账户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    localStorage.clear();
  },
  mounted() {
    this.getPictureCode();
  },
  methods: {
    //登陆
    onSubmit(values) {
      const that = this;
      if (values.imgcode.length !== 4) {
        Notify({ type: "danger", message: "请填写正确的验证码" });
        return false;
      } else {
        axios
          .post("/sys/loginByAgcustMobile", values)
          .then(function(res) {
            if (res.code == 200) {
              that.username = res.data.name;
              that.attorneyNo = res.data.attorneyNo;
              localStorage.setItem("openId", res.data.openId);
              localStorage.setItem("username", res.data.name);
              localStorage.setItem("authorization", res.data.authorization);
              localStorage.setItem("personid", res.data.personid);
              localStorage.setItem("depcode", res.data.coDeptnameCode);
              localStorage.setItem("hasAttorney", res.data.hasAttorney);
              localStorage.setItem("phone", values.psMobile);
              //提交用户设备信息
              that.submitUserDeviceInfo();
              Notify({ type: "success", message: "登陆成功" });
              //是否授权判断
              if (res.data.hasAttorney == 1) {
                that.showDoc();
              } else {
                Notify({ type: "warning", message: "未授权，仅限查阅操作" });
                that.$router.push({ path: "/mine" });
              }
            } else {
              Notify({ type: "danger", message: res.message });
            }
          })
          .catch(function(err) {
            // Notify({ type: "danger", message: err.message });
          });
      }
    },
    //获取图片验证码
    getPictureCode() {
      let that = this;
      axios
        .get("/sys/code", {
          responseType: "blob",
        })
        .then(function(res) {
          if (res) {
            that.imgCodeSrc = window.URL.createObjectURL(res);
          } else {
            Notify({ type: "danger", message: "图形验证码获取失败" });
          }
        });
    },
    //提交用户设备信息
    submitUserDeviceInfo() {
      const that = this;
      var md = new MobileDetect(navigator.userAgent); //初始化mobile-detect实例
      const brand = md.mobile(); //手机品牌
      const os_type = md.os(); //获取系统类型
      const os_version = md.version(os_type) || ""; //获取系统版本
      const device_type = navigator.userAgent; //获取userAgent信息
      localStorage.setItem("brand", brand);
      localStorage.setItem("os_type", os_type);
      localStorage.setItem("os_version", os_version);
      localStorage.setItem("device_type", JSON.stringify(device_type));
      // localStorage.setItem("ip", returnCitySN.cip);
      // localStorage.setItem("area", returnCitySN.cname);
      const params = {
        brand: brand,
        ostype: os_type,
        osversion: os_version,
        // ip: localStorage.getItem("ip"),
        // area: localStorage.getItem("area"),
        agcustid: localStorage.getItem("personid"),
      };
      axios
        .post("/exportxcx/deviceInformationSave", params)
        .then(function(res) {
          if (res.code == 200) {
          } else {
            Notify({ type: "danger", message: res.data.message });
          }
        })
        .catch(function(err) {});
    },
    //显示告知书
    showDoc() {
      let that = this;
      this.$dialog
        .confirm({
          title: "告知书",
          confirmButtonText: "同意",
          message: `根据编号${this.attorneyNo}授权书内容，您在“国贸云商外贸助手”操作的一切行为均视同为${this.username}的行为，由此引发的全部法律责任和法律后果均由${this.username}方承担。`,
        })
        .then(() => {
          that.$router.push({ path: "/mine" });
        })
        .catch(() => {
          // on cancel
        });
    },
    //跳转到注册
    toRegister() {
      this.$router.push({ path: "/register" });
    },
    //忘记密码
    toForget() {
      this.$router.push({ path: "/forget" });
    },

    handleClick() {},
  },
  components: {
    [Dialog.name]: Dialog,
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  height: 100%;
  padding-top: 48px;
  .login-title {
    width: 66px;
    margin-left: 34px;
    font-size: 28px;
    color: #000000;
    box-shadow: 0 -6px #1593fc inset;
  }
  .account-box {
    width: calc(100vw - 66px);
    margin: 0 auto;
    margin-top: 62px;
    .login-btn {
      width: 100%;
      height: 48px;
    }
    .tip {
      margin-top: 16px;
      color: #666;
      font-size: 12px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
<style lang="scss"></style>
